<template>
  <div class="pulse" :class="{ full: settings.full }">
    <main>
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </main>
    <notifications group="notify" />
    <user-edit v-if="userEdit" />
    <user-invite v-if="userInvite" />
    <confirm ref="confirm" />
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  computed: {
    ...mapState("app", ["settings", "popup"]),
    ...mapState("user", ["data"]),
    userEdit() {
      return this.popup.active && this.popup.type === "user-edit";
    },
    userInvite() {
      return this.popup.active && this.popup.type === "user-invite";
    }
  },
  async beforeMount() {
    if (this.data.token) {
      if (this.$route.name === "auth") {
        this.$router.push({ name: "finance_my" });
      }
      await this.getBasicData();
      await this.getUserByToken();
    }
    this.resolution();
    //window.onresize = () => this.resolution();
  },
  mounted() {
    const storage = this.$LS.get("storage");
    if (storage) this.loadUserSettings(storage);

    this.$root.$confirm = this.$refs.confirm.open;
  },
  methods: {
    ...mapActions("user", ["loadUserSettings", "getUserByToken"]),
    ...mapActions("app", ["setSettings", "getBasicData"]),
    resolution() {
      this.setSettings(
        Object.assign(this.settings, { full: this.$mediaQuery() === "mobile" })
      );
    }
  }
};
</script>
